<script> 
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AnktAnket from "@/models/AnktAnket"; 
export default {
  mixins: [Api, Sabit, AnktAnket],
  props: ["Baglanti", "IframeHtml"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader, 
  },
  watch: {
    Baglanti() {
      this.FormData = this.Id;
    },
    IframeHtml() {
      this.FormData = this.Id;
    },
  },
  methods: { 
    Get(){},
   
 
    
  },
};
</script>
<template>
  <Loader>
 <b-modal
      id="AnktAnketPaylas"
      size="lg"
      :title=" $t('AnktAnket.Paylas.Baslik') 
      "
      title-class="font-18"
      hide-footer
    >

<b-tabs content-class="p-3 text-muted">
            
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">
                    {{ $t('AnktAnket.Paylas.Baglanti.Baslik') }}
                  </span>
                </template>

                
           <div class="row">
             <div class="col-md-12">
             <input  
                           v-model="Baglanti"
                              type="text"
                              class="form-control"
                              
                            />
             </div>  </div>
              </b-tab>  <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">
                    {{ $t('AnktAnket.Paylas.Html.Baslik') }}
                  </span>
                </template>
             <div class="row">
             <div class="col-md-12">
             <input  
                           v-model="IframeHtml"
                              type="text"
                              class="form-control" 
                            />
             </div> </div>
              </b-tab>
 </b-tabs>

   </b-modal>

  </Loader>
</template>
